import { ApolloClient } from "apollo-client";
import { InMemoryCache } from "apollo-cache-inmemory";
import { HttpLink } from "apollo-link-http";
import { onError } from "apollo-link-error";
import { ApolloLink } from "apollo-link";

import Context from "shared/util/Context";
import isTest from "shared/util/isTest";
import getAccessToken from "shared/util/getAccessToken";

const graphqlUrl = Context.get("isLocal") && !Context.get("state").GRAPHQL_LOCAL
	? "https://bestproxy.dev.okcupid.com/graphql"
	: `https://${window.location.hostname}/graphql`;

const getPlatform = () => {
	if (Context && Context.get("platform")) {
		return Context.get("platform");
	} else {
		return "UNKNOWN";
	}
};

const buildHeaders = () => {
	const res = {};
	const platform = getPlatform();
	const accessToken = getAccessToken();

	if (platform === "DESKTOP" || platform === "MOBILE_SITE") {
		res["x-okcupid-platform"] = platform;
		res["x-okcupid-version"] = "1";
	} else {
		res["x-okcupid-platform"] = `${platform}_web`;
		res["x-okcupid-version"] = window && window.App ? window.App.app_version : "1";
	}

	if (accessToken) {
		res.Authorization = `Bearer ${accessToken}`;
	}

	return res;
};

const client = isTest()
	? {}
	: new ApolloClient({
		link: ApolloLink.from([
			onError(({ graphQLErrors, networkError }) => {
				if (graphQLErrors) {
					graphQLErrors.map(({ message, locations, path }) =>
						console.error(
							`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
						),
					);
				}

				if (networkError) {
					console.error(`[Network error]: ${networkError}`);
				}
			}),
			new HttpLink({
				uri: graphqlUrl,
				credentials: "include",
				headers: buildHeaders(),
			})
		]),
		cache: new InMemoryCache(),
	});

export default client;



// WEBPACK FOOTER //
// ./src/shared/util/ApolloClient.js